import { cn } from "lib/cn";
import LogoNegative from "../../assets/img/logo-icon-negative.svg?react";
import Logo from "../../assets/img/logo-icon.svg?react";

interface SpinnerProps {
    className?: string;
    size?: "sm" | "md" | "lg" | "xl";
    negativeLogo?: boolean;
}

const sizeClasses = {
    sm: "h-6 w-6",
    md: "h-10 w-10",
    lg: "h-16 w-16",
    xl: "h-24 w-24",
};

export const Spinner = ({ className, size = "xl", negativeLogo = false }: SpinnerProps) => {
    const LogoComponent = negativeLogo ? LogoNegative : Logo;
    return (
        <div className={cn("flex items-center justify-center", sizeClasses[size], className)}>
            {/* CSS keyframes (index.css) replace framer-motion, same timing: a 2s linear
                spin around a 1.5s pulse (opacity 0.6 → 1, scale 0.95 → 1.2). */}
            <div className="compass-spinner-rotate" style={{ width: "100%", height: "100%" }}>
                <div className="compass-spinner-pulse" style={{ width: "100%", height: "100%" }}>
                    <LogoComponent style={{ width: "100%", height: "100%" }} />
                </div>
            </div>
        </div>
    );
};
